<template>
  <v-sheet color="transparent">
    <TopSection />
    <AboutSection />
    <VerticalCarrouselSection />
  </v-sheet>
</template>

<script>
import TopSection from "../components/sections/algoamais/TopSection.vue";
import AboutSection from "../components/sections/algoamais/AboutSection.vue";
import VerticalCarrouselSection from "../components/sections/algoamais/VerticalCarrouselSection.vue";

export default {
  components: {
    TopSection,
    AboutSection,
    VerticalCarrouselSection,
  },
};
</script>
